import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
//import sonido from '../audio/grup.mp3'
import sonido from '../../audio/grup.mp3'
import { Link } from 'react-router-dom'

const Chatgrup = ({ groupId }) => {
    const { auth } = useSelector(state => state);
    const { socket } = useSelector(state => state);
    const [messages, setMessages] = useState([]);
    const [text, setText] = useState('');
    const [alias, setAlias] = useState(() => localStorage.getItem('groupAlias') || '');
    const [joined, setJoined] = useState(!!localStorage.getItem('groupAlias'));
    const chatRef = useRef(null);
    const soundRef = useRef(null);
    const [muted, setMuted] = useState(() => {
        return localStorage.getItem('groupMuted') === 'true';
    });
    const [connectedUsers, setConnectedUsers] = useState([]);
    const [typingUsers, setTypingUsers] = useState([]);
    const [avatar, setAvatar] = useState(() =>
        localStorage.getItem('groupAvatar') || auth.user?.avatar || ''
    );
    const [editavatar, setEditavatar] = useState(false)
    const typingTimeout = useRef(null);
    const togleditavatar = () => {
        setEditavatar(!editavatar)
    }

    const handleTyping = (e) => {
        setText(e.target.value);
        socket.emit('typing', { groupId, user: { username: alias } });
        // Si no escribe en 3s, emitir stop
        clearTimeout(typingTimeout.current);
        typingTimeout.current = setTimeout(() => {
            socket.emit('stopTyping', { groupId });
        }, 3000);
    };

    const toggleMute = () => {
        setMuted(prev => {
            const next = !prev;
            localStorage.setItem('groupMuted', next);
            return next;
        });
    };

    // ⬅️ Esta carga se hace al entrar, y también cada vez que alias cambia (es decir, usuario entra)
    useEffect(() => {
        const saved = localStorage.getItem(`groupMessages-${groupId}`);
        if (saved) {
            setMessages(JSON.parse(saved));
        }
    }, [groupId, alias]);

    // Mantén el scroll abajo
    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [messages]);

    // Unirse/salirse del grupo con alias válido
    useEffect(() => {
        if (alias && socket) {
            //socket.emit('joinGroup', { groupId });
            socket.emit('joinGroup', { groupId, user: { username: alias } });
            return () => {
                socket.emit('leaveGroup', { groupId });
            };
        }
    }, [groupId, socket, alias]);

    useEffect(() => {
        const handler = (e) => {
            if (e.detail.groupId === groupId) {
                const saved = localStorage.getItem(`groupMessages-${groupId}`);
                if (saved) {
                    const parsed = JSON.parse(saved);
                    setMessages(parsed);
                    // Reproduce el sonido solo si el último mensaje no es del propio usuario
                    const last = parsed[parsed.length - 1];
                    if (last?.user?.username !== alias && !muted) {
                        soundRef.current?.play().catch(err => {
                            console.error('Error al reproducir sonido', err);
                        });
                    }
                }
            }
        };
        window.addEventListener('new-group-message', handler);
        return () => window.removeEventListener('new-group-message', handler);
    }, [groupId, alias, muted]);

    useEffect(() => {
        if (!socket) return;
        const handleGroupHistory = ({ groupId: incomingGroupId, messages }) => {
            if (incomingGroupId === groupId) {
                setMessages(messages);
                // Guardar en localStorage
                localStorage.setItem(`groupMessages-${groupId}`, JSON.stringify(messages));
            }
        };
        socket.on('groupMessageHistory', handleGroupHistory);
        return () => {
            socket.off('groupMessageHistory', handleGroupHistory);
        };
    }, [socket, groupId]);

    /**escuchar usuarios conectados */
    useEffect(() => {
        if (!socket) return;
        const handler = (users) => {
            setConnectedUsers(users);
        };
        socket.on('groupUsersUpdate', handler);
        return () => {
            socket.off('groupUsersUpdate', handler);
        };
    }, [socket]);
    ///

    useEffect(() => {
        if (!socket) return;
        const handleTyping = (usersTyping) => {
            // Excluirme a mí mismo
            const others = usersTyping.filter(u => u.username !== alias);
            setTypingUsers(others);
        };
        socket.on('typingUpdate', handleTyping);
        return () => {
            socket.off('typingUpdate', handleTyping);
        };
    }, [socket, alias]);

    const handleSend = () => {
        if (!text.trim()) return;
        if (text.length > 300) {
            alert("El mensaje no puede superar los 300 caracteres");
            return;
        }
        const msg = {
            groupId,
            user: {
                username: alias,
                avatar: avatar || '', // puede ser emoji o URL
            },
            text,
            createdAt: new Date().toISOString()
        };
        socket.emit('sendGroupMessage', msg);
        setMessages(prev => [...prev, msg]); // Mostrar el mensaje localmente
        setText('');
        socket.emit('stopTyping', { groupId });
    };
    /*if (!joined) {
        return (
            <div className="p-3">
                <h5>Ingresa tu alias para unirte al chat grupal</h5>
                <input
                    className="form-control my-2"
                    placeholder="Tu alias"
                    value={alias}
                    onChange={e => {
                        if (e.target.value.length <= 20) {
                            setAlias(e.target.value);
                        }
                    }}
                />
                <input
                    type="text"
                    className="form-control my-2"
                    placeholder="Avatar (puede ser un emoji o URL de imagen)"
                    value={avatar}
                    onChange={e => setAvatar(e.target.value)}
                />
                <button
                    className="btn btn-primary"
                    onClick={() => {
                        if (alias.trim() && alias.trim().length <= 20) {
                            localStorage.setItem('groupAlias', alias.trim());
                            localStorage.setItem('groupAvatar', avatar.trim());
                            setJoined(true);
                        } else {
                            alert("El alias debe tener entre 1 y 20 caracteres");
                        }
                    }}

                >
                    Unirse al chat
                </button>
            </div>
        );
    }*/


    {
        !joined && (
            <div style={{
                position: 'fixed',
                top: 0, left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
            }}>
                <div style={{
                    background: '#fff',
                    padding: '2rem',
                    borderRadius: '10px',
                    width: '90%',
                    maxWidth: '400px',
                    textAlign: 'center'
                }}>
                    <h5 className="mb-3">Ingresa tu alias para unirte al chat grupal</h5>
                    <input
                        className="form-control my-2"
                        placeholder="Tu alias"
                        value={alias}
                        onChange={e => {
                            if (e.target.value.length <= 20) {
                                setAlias(e.target.value);
                            }
                        }}
                    />
                    <input
                        type="text"
                        className="form-control my-2"
                        placeholder="Avatar (emoji o URL de imagen)"
                        value={avatar}
                        onChange={e => setAvatar(e.target.value)}
                    />
                    <button
                        className="btn btn-primary w-100 mt-2"
                        onClick={() => {
                            if (alias.trim() && alias.trim().length <= 20) {
                                localStorage.setItem('groupAlias', alias.trim());
                                localStorage.setItem('groupAvatar', avatar.trim());
                                setJoined(true);
                            } else {
                                alert("El alias debe tener entre 1 y 20 caracteres");
                            }
                        }}
                    >
                        Unirse al chat
                    </button>
                </div>
            </div>
        )
    }


    return (
        <div className="p-3">
            <h5 className="mb-2">Chat del grupo: {groupId}</h5>
            <Link to='/grupos-de-chats'>
                <button
                    className="btn btn-sm btn-outline-dark mb-2"
                >
                    🔙 Volver a elegir grupo
                </button>
            </Link>


            <div className="mb-2">
                <strong>Conectados ({connectedUsers.length}):</strong>{' '}
                <div className="connected-users-list overflow-auto d-flex flex-nowrap fs-6">
                    {connectedUsers.map((u, i) => (
                        <span key={i} className="badge bg-info text-dark m-1">
                            {u.username}
                        </span>
                    ))}
                </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-2">
                {/*<h5 className="mb-0">Chat del Grupo</h5>*/}
                <div className="mb-2">
                    <label className="form-label">Avatar:</label>
                    <div>
                        {avatar?.startsWith('http') ? (
                            <img
                                src={avatar}
                                alt="avatar"
                                style={{ width: 40, height: 40, borderRadius: '50%', marginRight: 10 }}
                            />
                        ) : (
                            <span style={{ fontSize: '2rem', marginRight: 10 }}>{avatar}</span>
                        )}
                    </div>

                    <button onClick={togleditavatar} className='btn_edit_avatar'>
                        {
                            editavatar ? 'Ocultar' : 'Editar'
                        }
                    </button>
                    {
                        editavatar && (
                            <div>
                                <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => {
                                            setAvatar(auth.user?.avatar || '');
                                            localStorage.setItem('groupAvatar', auth.user?.avatar || '');
                                        }}
                                    >
                                        Usar avatar perfil
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-secondary m-1"
                                        onClick={() => {
                                            setAvatar('');
                                            localStorage.removeItem('groupAvatar');
                                        }}
                                    >
                                        Limpiar
                                    </button>
                                </div>
                                {/* Selector de íconos prediseñados */}
                                <select
                                    className="form-select mb-2"
                                    onChange={e => {
                                        setAvatar(e.target.value);
                                        localStorage.setItem('groupAvatar', e.target.value);
                                    }}
                                    value={avatar}
                                >
                                    <option value="">Elegí un avatar rápido</option>
                                    <option value="🦊">🦊 Zorro</option>
                                    <option value="🐱">🐱 Gato</option>
                                    <option value="🐶">🐶 Perro</option>
                                    <option value="🐸">🐸 Rana</option>
                                    <option value="🐼">🐼 Panda</option>
                                    <option value="🌸">🌸 Flor</option>
                                    <option value="💀">💀 Calavera</option>
                                    <option value="🔥">🔥 Fuego</option>
                                    <option value="👾">👾 Alien</option>
                                    <option value="🤖">🤖 Robot</option>
                                </select>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Puedes usar el URL de imagen aqui"
                                    value={avatar}
                                    onChange={e => {
                                        setAvatar(e.target.value);
                                        localStorage.setItem('groupAvatar', e.target.value);
                                    }}
                                />
                            </div>
                        )
                    }
                </div>

                <div className="d-flex mb-3 align-items-center">
                    <input
                        className="form-control me-2"
                        style={{ maxWidth: 200 }}
                        value={alias}
                        onChange={e => {
                            setAlias(e.target.value);
                            localStorage.setItem('groupAlias', e.target.value);
                        }}
                        placeholder="Ingresa tú alias"
                    />
                    <button
                        className="btn btn-sm btn-outline-secondary m-2"
                        onClick={() => {
                            localStorage.removeItem('groupAlias');
                            setAlias('');
                        }}
                    >
                        Borrar
                    </button>
                </div>
                {/*<button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => {
                        localStorage.removeItem('groupAlias');
                        setAlias('');
                        setJoined(false);
                        setMessages([]);
                    }}
                >
                    Cambiar alias
                </button>*/}
            </div>
            <div className="d-flex justify-content-end">
                <button
                    className={`btn btn-sm ${muted ? 'btn-secondary' : 'btn-warning'} ms-2 m-2 `}
                    //onClick={() => setMuted(prev => !prev)}
                    onClick={toggleMute}
                >
                    {muted ? '🔇 Silenciado' : '🔔 Sonando'}
                </button>
            </div>
            <div className='contenedor_chatglobal'>
                <div className="chat-container mb-2" ref={chatRef}>
                    <div className='hear-chat-container' >
                        {typingUsers.length > 0 && (
                            <div className="typing-indicator mb-2 text-muted fst-italic">
                                {typingUsers.map(u => u.username).join(', ')} {typingUsers.length > 1 ? 'están' : 'está'} escribiendo...
                            </div>
                        )}
                    </div>
                    {messages.map((msg, i) => {
                        const isOwn = msg.user.username === alias;
                        const time = new Date(msg.createdAt).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                        return (
                            <div key={i} className={`message-row ${isOwn ? 'message-right' : 'message-left'}`}>
                                <div className={`message-bubble ${isOwn ? 'right' : ''}`}>
                                    <div className="d-flex align-items-center mb-1">
                                        {msg.user.avatar && (
                                            <div className="me-2">
                                                {msg.user.avatar.startsWith('http') ? (
                                                    <img
                                                        src={msg.user.avatar}
                                                        alt="avatar"
                                                        style={{ width: 24, height: 24, borderRadius: '50%' }}
                                                    />
                                                ) : (
                                                    <span style={{ fontSize: '1.5rem' }}>{msg.user.avatar}</span>
                                                )}
                                            </div>
                                        )}
                                        <strong>{msg.user.username}</strong>
                                    </div>
                                    <div>{msg.text}</div>
                                    <div className="message-meta">{time}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="input-group">
                    <input
                        className="form-control"
                        placeholder="Escribe tu mensaje..."
                        value={text}
                        //onChange={e => setText(e.target.value)}
                        onChange={e => {
                            if (e.target.value.length <= 300) {
                                handleTyping(e); // mantiene funcionalidad de typing
                            }
                        }}
                        onKeyDown={e => e.key === 'Enter' && handleSend()}
                    />
                    <small className="text-muted">
                        {text.length}/300 caracteres
                    </small>
                    <button className="btn btn-success" onClick={handleSend}>
                        Enviar
                    </button>
                </div>
            </div>
            <audio ref={soundRef} src={sonido} preload="auto" />
        </div>
    );
};

export default Chatgrup;
